import React from 'react';
import { CanonicalAvatar } from '@atlassian/trello-canonical-components';
import Icon, { IconName } from 'app/common/components/controls/icon';

interface TeamLogo {
  className: string;
  url?: string;
  size: number;
}

export const TeamLogo = (props: TeamLogo) => {
  const { className, url, size } = props;
  if (url) {
    return <CanonicalAvatar className={className} img={url} size={size} />;
  }
  return <Icon name={IconName.Organization} large />;
};
